import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import config from "./config";

// --- FIX: swallow ResizeObserver errors (simple & safe) ---
window.addEventListener(
  "error",
  (e) => {
    if (e.message?.includes("ResizeObserver")) {
      e.stopImmediatePropagation();
    }
  },
  true
);
// -----------------------------------------------------------

ReactDOM.render(
  <GoogleOAuthProvider clientId={config.clientId}>
    <App />
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

reportWebVitals();
